import React from 'react';
import '../styles/HydraulicExcavators.css';

const HydraulicExcavators = () => {
  return (
    <section className="hydraulic-excavators">
      <div className="excavator-container">
        <div className="excavator-text">
          <h2 className="excavator-title">PELLES HYDRAULIQUES</h2>
          <h3 className="excavator-tonnage">22 À 52 TONNES</h3>
          <p className="excavator-tagline">" Découvrez la puissance et la précision "</p>
          
          <div className="excavator-description">
            <p>
              Notre gamme de pelles hydrauliques offre des performances optimales pour
              tous vos chantiers, avec une diversité de modèles allant du compact au grand
              tonnage. Robustesse, fiabilité et efficacité sont au rendez-vous.
            </p>
          </div>
          
          <a href="/products/excavator" className="excavator-button">
            NOS PELLES
          </a>
        </div>
        
        <div className="excavator-image">
          <img 
            src="/assets/images/excavator.png" 
            alt="Pelle hydraulique LiuGong" 
          />
        </div>
      </div>
    </section>
  );
};

export default HydraulicExcavators;